// AI Studio's Undo: the assistant's last batch of edits comes first (the
// editor history does not record them), then the editor's own history.
export function resolveStudioUndo({ assistantEditPending, editorCanUndo }: {
  assistantEditPending: boolean;
  editorCanUndo: boolean;
}): { canUndo: boolean; source: 'assistant' | 'editor' | null } {
  if (assistantEditPending) return { canUndo: true, source: 'assistant' };
  if (editorCanUndo) return { canUndo: true, source: 'editor' };
  return { canUndo: false, source: null };
}
